import { Pipe, PipeTransform } from '@angular/core';
import { O } from '@macs-frontend/core/utils/fp-ts';

@Pipe({ name: 'isSome', pure: true })
export class IsSomePipe implements PipeTransform {
  public transform<T>(value: O.Option<T>): value is O.Some<T> {
    return O.isSome(value);
  }
}
